<template>
  <Header_en_m/>
  <a-input-search
      v-model:value="value.item"
      :placeholder="'input search text'"
      enter-button
      @search="search"
      size="large"
      style="padding-top: 15vh; width: 80vw;line-height: 5vh"
      pressEnter="search"
  />
  <div v-if="value.visible" class="result_page">
    <p style="font-size: 1vh">There are {{ result.enterprise.length + result.news.length }} results about "{{ value.item }}"</p>
    <p style="margin-bottom: 0.5vh;background: #7c7cff;color: white;text-align: center">Portfolio</p>
    <div v-if="result.enterprise.length > 0">
      <div style="border-bottom-style: solid; border-color: #cacaca; border-width: 1px"
           v-for="(item, index) in result.enterprise" :key="index" @click="showmodal(index, 'enterprise')">
        <p style="text-indent: 1em;font-size: 2.5vh;margin-bottom: 0.5vh">{{ item.name_en }}</p>
        <p style="font-size: 1.8vh;overflow: hidden;width: 84vw; white-space: nowrap; text-overflow: ellipsis;">
          {{ item.introduction_en[0] }}</p>
      </div>
    </div>
    <div v-else>
      <p>There is no result about "{{ value.item }}"</p>
    </div>
    <p style="margin-bottom: 0.5vh;background: #7c7cff;color: white;text-align: center">News</p>
    <div v-if="result.news.length > 0">
      <div style="border-bottom-style: solid; border-color: #cacaca; border-width: 1px"
           v-for="(item, index) in result.news" :key="index" @click="showmodal(index, 'news')">
        <p style="text-indent: 1em;font-size: 2.5vh;margin-bottom: 0.5vh">{{ item.title }}</p>
        <p style="font-size: 1.8vh;overflow: hidden;width: 84vw; white-space: nowrap; text-overflow: ellipsis;">
          {{ item.summary }}</p>
      </div>
    </div>
    <div v-else>
      <p>There is no result about "{{ value.item }}"</p>
    </div>
  </div>
  <a-modal v-model:visible="modal_enterprise.visible" @click="close"
           :centered="true" :footer="null" :width="'40vh'"
           :bodyStyle="{padding: 0,}" :destroyOnClose="true">
    <div v-if="modal_enterprise.picture_owner" class="enterprise_item_detail">
      <img :src="modal_enterprise.picture_owner">
      <div style="z-index: 2;position: absolute; top:26vw; left: 6vw">
        <p style="margin: 0; font-size: 18px">{{ modal_enterprise.name }}</p>
        <p>——</p>
        <p style="font-size: 18px">{{ modal_enterprise.owner }}</p>
      </div>
      <a-row style="display: flex; align-items: center" class="text_field">
        <div style="text-align: center; width: 40vh">
          <a-row style="padding-top: 1vh">
            <p style="font-size: 3vh;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
              {{ modal_enterprise.name }}</p>
            <LinkOutlined v-if="(modal_enterprise.site)" @click="tosite(modal_enterprise.site)"
                          style="font-size: 3vh;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
          </a-row>
          <ul style="text-align: center; width: 35vh; margin-bottom: 1vh;max-height: 60vw;overflow-y: scroll">
            <li v-for="(item, index) in modal_enterprise.introduction" :key="index"
                style="text-align: left;font-size: 2vh; margin-bottom: 1em">
              {{ item }}
            </li>
          </ul>
          <a-row style="text-align: center">
            <img :src="modal_enterprise.trademark"
                 style="height: 5vw; width:auto;filter: brightness(100%);">
          </a-row>
        </div>
      </a-row>

    </div>
    <div v-else>
      <div style="width: 40vh; text-align: center;height: 80vh; margin: 0">
        <a-row style="padding-top: 2vw;">
          <p style="font-size: 32px;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
            {{ modal_enterprise.name }}</p>
          <LinkOutlined v-if="(modal_enterprise.site)" @click="tosite(modal_enterprise.site)"
                        style="font-size: 26px;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
        </a-row>
        <p style="color: dimgrey">—————</p>
        <ul style="text-align: center; width: 70vw; margin: 0 5vw;overflow-x: hidden;height: 50vh;max-height: 50vh;font-size: 16px;overflow-y: scroll">
          <li v-for="(item, index) in modal_enterprise.introduction" :key="index"
              style="text-align: left; margin-bottom: 1em;font-size: 16px;">
            {{ item }}
          </li>
        </ul>
        <a-row style="height: 6vw;text-align: center">
          <img :src="modal_enterprise.trademark"
               style="width:250px; height: auto; filter: brightness(100%);">
        </a-row>
      </div>
    </div>

  </a-modal>


</template>
<script>
import axios from 'axios'
import {reactive,} from 'vue'
import Header_m from "@/components/CN_mobile/Header_m";
import {LinkOutlined} from "@ant-design/icons-vue/"
import Header_en_m from "@/components/EN_mobile/Header_en_m";

export default {
  name: 'Search_en_m',
  components: {Header_en_m, Header_m, LinkOutlined},
  setup() {
    const value = reactive({
      item: '',
      visible: false,
    })
    const result = reactive({
      enterprise: [],
      news: [],
    })
    const modal_enterprise = reactive({
      visible: false,
      name: '',
      site: '',
      owner: '',
      introduction: '',
      picture_owner: '',
      trademark: '',
    })
    const modal_news = reactive({
      visible: false,
      title: '',
      date: '',
      summary: '',
      introduction: '',
    })
    const close = (e) => {
      console.log(e)
      modal_news.visible = false
      modal_enterprise.visible = false
    }
    const tosite = (site) => {
      window.open(site)
    }
    const showmodal = (index, category) => {
      if (category === 'enterprise' && result.enterprise[index]['status'] !== "perished") {
        modal_enterprise.visible = true
        modal_enterprise.name = result.enterprise[index]['name']
        modal_enterprise.site = result.enterprise[index]['site']
        modal_enterprise.owner = result.enterprise[index]['owner']
        modal_enterprise.introduction = result.enterprise[index]['introduction_en']
        modal_enterprise.picture_owner = result.enterprise[index]['picture_owner']
        modal_enterprise.trademark = result.enterprise[index]['trademark']
      } else if (category === 'news') {
        modal_news.visible = true
        modal_news.title = result.news[index].title
        modal_news.date = result.news[index].date
        modal_news.summary = result.news[index].summary
        modal_news.introduction = result.news[index].introduction
      }
    }
    const search = () => {
      if (value.item.length > 0) {
        value.visible = true
        let params = new URLSearchParams()
        params.append("value", value.item)
        axios.post('https://sig-china.com:8081/api/search_en/', params)
            .then((res) => {
              console.log(res.data)
              result.enterprise = res.data[0]
              result.news = res.data[1]
              result.enterprise.sort((a, b) => {
                return a['id'] - b['id']
              })
              result.news.sort((a, b) => {
                return a['id'] - b['id']
              })
              for (let i = 0; i < result.enterprise.length; i++) {
                result.enterprise[i]["trademark"] = 'https://sig-china.com' + result.enterprise[i]["trademark"]
                if (result.enterprise[i]["picture_owner"]) {
                  result.enterprise[i]["picture_owner"] = 'https://sig-china.com' + result.enterprise[i]["picture_owner"]
                }
                if (result.enterprise[i]["introduction_en"].indexOf('\r\n') !== -1) {
                let temp = result.enterprise[i]["introduction_en"]
                result.enterprise[i]["introduction_en"] = []
                while (temp.indexOf('\r\n') !== -1) {
                  let pointer = temp.indexOf('\r\n')
                  result.enterprise[i]["introduction_en"].push(temp.slice(0, pointer))
                  temp = temp.slice(pointer + 2,)
                }
                result.enterprise[i]["introduction_en"].push(temp)
              } else {
                result.enterprise[i]["introduction_en"] = [result.enterprise[i]["introduction_en"]]
              }

              }
            })
      }
    }

    return {value, tosite, search, result, modal_enterprise, modal_news, showmodal, close}
  }
}
</script>
<style scoped>
.result_page {
  padding-top: 2vh;
  margin: 0 8vw;

}

.result_page p {
  color: #7a7a7a;
  text-align: left;
}
.enterprise_item_detail img {
  width: 100%;
  height: 100%;
  max-width: 40vh;
  filter: brightness(80%)
}
.text_field{
  height: calc(94vh - 40vh);
}
</style>
